import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export interface SchemaState {
  delivery_id: number | null;
}

const initialState: SchemaState = {
  delivery_id: null,
};

const schemaSlice = createSlice({
  name: 'schema',
  initialState,
  reducers: {
    setSchema(state, action: PayloadAction<number | null>) {
      return { ...state, delivery_id: action.payload, error: null, loading: false };
    },
  },
});

// Actions
export const schemaActions = schemaSlice.actions;

// Selectors
export const selectDeliveryId = (state: RootState) => state.schema.delivery_id;

// Reducer
export const schemaReducer = schemaSlice.reducer;
